import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const AgentKey = 'AgentId'
const AgentInfo = 'AgentInfo'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getAgent() {
  return Cookies.get(AgentKey)
}

export function setAgent(data) {
  return Cookies.set(AgentKey, data)
}

export function removeAgent() {
  return Cookies.remove(AgentKey)
}

export function getAgentInfo() {
  return Cookies.get(AgentInfo)
}

export function setAgentInfo(data) {
  return Cookies.set(AgentInfo, data)
}

export function removeAgentInfo() {
  return Cookies.remove(AgentInfo)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js